import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./starbucks_coupon_type.js";
//#region src/starbucks_coupon_type_helper.ts
var starbucks_coupon_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(couponType) {
	switch (couponType) {
		case "villa-airport-employee-discount-15%": return "Villa Airport Employee (15%)";
	}
}
//#endregion
export { name, starbucks_coupon_type_helper_exports };

//# sourceMappingURL=starbucks_coupon_type_helper.js.map